import { render, staticRenderFns } from "./ChecklistItensModal.vue?vue&type=template&id=71179b50&scoped=true"
import script from "./ChecklistItensModal.vue?vue&type=script&lang=js"
export * from "./ChecklistItensModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71179b50",
  null
  
)

export default component.exports